import { useEffect } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Explore from '../../pages/Explore/Explore';
import Home from '../../pages/Home/Home';
import Lifestyle from '../../pages/category/Lifestyle/Lifestyle';
import MentalHealth from '../../pages/category/MentalHealth/MentalHealth';
import Sleep from '../../pages/subcategory/sleep/Sleep';
import Support from '../../pages/Support/Support';
import MyJaaq from '../../pages/MyJaaq/MyJaaq';
import Footer from '../Footer/Footer';
import useScreenSize from '../../core/hooks/useScreenSize';
import { useFooterContext } from '../../core/context/FooterContext';
import ExperienceSleep from '../../pages/experience/Sleep/ExperienceSleep';
import LearningDifferencies from '../../pages/category/LearningDifferencies/LearningDifferencies';
import Wellbeing from '../../pages/category/Wellbeing/Wellbeing';
import Therapy from '../../pages/category/Therapy/Therapy';
import Workplace from '../../pages/category/Workplace/Workplace';
import Diversity from '../../pages/category/Diversity/Diversity';
import MenWomenHealth from '../../pages/category/MenWomenHealth/MenWomenHealth';
import Yoga from '../../pages/subcategory/yoga/Yoga';
import ExperienceYoga from '../../pages/experience/Yoga/ExperienceYoga';
import Depression from '../../pages/subcategory/depression/Depression';
import ExperienceDepressionPaul from '../../pages/experience/Depression/ExperienceDepressionPaul';
import ExperienceDepressionAlastair from '../../pages/experience/Depression/ExperienceDepressionAlastair';

function App() {
  const [size] = useScreenSize();
  const { footerData } = useFooterContext();

  useEffect(() => {
    localStorage.getItem('likedExperiences') === null &&
      localStorage.setItem('likedExperiences', JSON.stringify([0]));
    localStorage.getItem('savedArticles') === null &&
      localStorage.setItem('savedArticles', JSON.stringify([0]));
    localStorage.getItem('savedQuestions') === null &&
      localStorage.setItem('savedQuestions', JSON.stringify([{}]));
  }, []);

  // TODO: Delte this

  return (
    <div className="app">
      <Routes>
        <Route exact path="/" element={<Navigate to="/home" replace />} />
        <Route path="/home" element={<Home />} />
        <Route path="/category" element={<Explore />} />
        <Route path="/category/lifestyle" element={<Lifestyle />} />
        <Route path="/category/lifestyle/sleep" element={<Sleep />} />
        <Route path="/category/wellbeing/yoga" element={<Yoga />} />
        <Route path="/category/mentalhealth" element={<MentalHealth />} />
        <Route path="/category/mentalhealth/depression" element={<Depression />} />
        <Route path="/category/differences" element={<LearningDifferencies />} />
        <Route path="/category/wellbeing" element={<Wellbeing />} />
        <Route path="/category/therapies" element={<Therapy />} />
        <Route path="/category/workplace" element={<Workplace />} />
        <Route path="/category/diversity-and-inclusion" element={<Diversity />} />
        <Route path="/category/men-woman-health" element={<MenWomenHealth />} />
        <Route path="/support" element={<Support />} />
        <Route path="/myJAAQ" element={<MyJaaq />} />
        <Route path="/experience/sleep" element={<ExperienceSleep />} />
        <Route path="/experience/depression-paul" element={<ExperienceDepressionPaul />} />
        <Route path="/experience/depression-alastair" element={<ExperienceDepressionAlastair />} />
        <Route path="/experience/yoga" element={<ExperienceYoga />} />
      </Routes>

      {size > 991 && <Footer data={footerData} />}
    </div>
  );
}

export default App;
